import React from 'react';

const painPoints = [
  {
    title: 'Relying on contact forms',
    detail: 'Leads go cold after hours. Customers move on before you can respond.'
  },
  {
    title: 'Answering calls while on the job',
    detail: 'Missed calls = missed jobs. It’s hard to juggle crews and phones.'
  },
  {
    title: 'Generic lead sites',
    detail: 'Shared leads and bidding wars drive down margins and waste time.'
  },
  {
    title: 'DIY ads that don’t convert',
    detail: 'Clicks without conversations mean spend without booked jobs.'
  },
];

const benefits = [
  {
    title: 'Instant conversations',
    detail: 'Our on‑site assistant engages visitors immediately and books next steps.'
  },
  {
    title: 'Home service focus',
    detail: 'Built for home service businesses—messaging that matches how people book.'
  },
  {
    title: 'Hands‑off lead handling',
    detail: 'Leads are captured, organized, and texted to you automatically.'
  },
  {
    title: 'Better ROI from ads',
    detail: 'Turn paid clicks into real conversations and scheduled appointments.'
  },
];

export function ComparisonSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why the Usual Way Loses Jobs - And What Works Instead
          </h2>
          <p className="font-subheading text-xl text-gray-600 max-w-3xl mx-auto">
            Replace missed calls and cold forms with real conversations that turn into booked estimates.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
            <h3 className="font-heading text-2xl font-semibold text-gray-900 mb-4">The Old Way</h3>
            <ul className="space-y-4">
              {painPoints.map((item) => (
                <li key={item.title} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-red-100 text-red-600 flex items-center justify-center mt-1">–</div>
                  <div>
                    <div className="font-subheading font-medium text-gray-900">{item.title}</div>
                    <div className="font-subheading text-gray-600">{item.detail}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-8 border border-green-200">
            <h3 className="font-heading text-2xl font-semibold text-gray-900 mb-4">Our Way</h3>
            <ul className="space-y-4">
              {benefits.map((item) => (
                <li key={item.title} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-green-100 text-green-700 flex items-center justify-center mt-1">✓</div>
                  <div>
                    <div className="font-subheading font-medium text-gray-900">{item.title}</div>
                    <div className="font-subheading text-gray-600">{item.detail}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ComparisonSection;


